import Vue from 'vue'
import Router from 'vue-router'

import Main from '../components/Main.vue'
import Login from '../components/Login.vue'
import RetencaoOnline from '../components/public/campanhas/RetencaoOnline.vue'

import PageNotFound from '../components/PageNotFound.vue'

import Operacional from '../components/Operacional.vue'
import Sale from '../components/Sale.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/campanha/retencao-online',
      name: 'RetencaoOnline',
      component: RetencaoOnline
    },
    {
      path: '/',
      redirect: '/login',
      component: Main,
      children: [{
          path: '/sale',
          name: 'Venda',
          component: Sale
        },
        {
          path: '/main',
          name: 'Main',
          component: Operacional
        },
      ]
    },
    {
      path: '*',
      component: PageNotFound
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js